import { useContext, useEffect, useRef, useState } from "react";
import "./Catalog.css";
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { CATALOG_MAIN_LINK } from "../../assets/utils/constants";
import { buildCategoryPath } from "../../assets/utils/utils";
import { Helmet } from "react-helmet";
import MiniPreloader from "../MiniPreloader/MiniPreloader";
import CategoryCard from "./CategoryCard/CategoryCard";
import Products from "./Products/Products";
import mainApi from "../../assets/api/MainApi";
import { ConfigContext } from "../../assets/contexts/configContext";
import { FiltersContext } from "../../assets/contexts/filtersContext";
import FiltersPopup from "./Products/FiltersPopup/FiltersPopup";

function parse_filters(filters, searchParams) {
  if (!filters || filters.length === 0) return null
  return filters.map((filter) => {
    let valueFromParams = searchParams ? searchParams.get(`filter_${filter._id}`) : null;
    if (valueFromParams) {
      console.log(filter, valueFromParams)

      switch (filter.data_type) {
        case 'range': {
          const [GTE, LTE] = valueFromParams.split('-').map(Number);
          return {
            ...filter,
            value: [GTE, LTE]
          };
        }
        case 'bool': {
          return {
            ...filter,
            value: JSON.parse(valueFromParams)
          };
        }
        case 'string':
        case 'integer': {
          try {
            // Попробуем распарсить как массив
            const parsedValue = JSON.parse(valueFromParams);

            if (Array.isArray(parsedValue)) {
              return {
                ...filter,
                value: parsedValue
              };
            } else {
              // Если это не массив, добавляем как есть
              return {
                ...filter,
                value: valueFromParams
              };
            }
          } catch (error) {
            // Если не получилось распарсить как JSON, просто добавим как строку
            return {
              ...filter,
              value: valueFromParams
            };
          }
        }
        default: {
          return null
        }
      }
    } else {
      //   Default value handling
      switch (filter.data_type) {
        case 'range': {
          const GTE = filter.features.gte;
          const LTE = filter.features.lte;
          return {
            ...filter,
            value: [GTE, LTE]
          };
        }
        case 'bool': {
          return {
            ...filter,
            value: filter.filter_type === 'in_stock' ? false : null
          };
        }
        default: {
          return filter;
        }
      }
    }
  }).filter((item) => Boolean(item));
}

const PRODUCTS_LIMIT = 24

function usePrevious(value) {
  const ref = useRef(null);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

function Catalog({ levels }) {
  const [searchParams, setSearchParams] = useSearchParams()
  const prevLevels = usePrevious(levels);
  const config = useContext(ConfigContext)
  const { initialConstants } = config
  const { SHOP_ID_FOR_API, SHOP_NAME, USING_FILTERS } = initialConstants
  const location = useLocation();
  const navigate = useNavigate();
  const [preloaders, setPreloaders] = useState({
    item: true,
    more: false,
    products: true,
    subcategories: true,
  });
  const [popups, setPopups] = useState({
    filters: false,
  })
  const [category, setCategory] = useState(undefined);

  const [filterValues, setFilterValues] = useState(null)

  const loadMoreRef = useRef(null);

  useEffect(() => {
    // Сравнение предыдущего и текущего значения levels
    console.log(JSON.stringify(prevLevels), JSON.stringify(levels))
    if (JSON.stringify(prevLevels) === JSON.stringify(levels)) {
      return; // Если массив levels не изменился, выходим из useEffect
    }

    console.log({
      levels: {
        levels,
        length: levels.length,
      }
    });
    if (!levels || levels.length <= 0) {
      setCategory({
        _id: null,
        title: 'Catalog',
        path: null,
        categories: [],
        filters: [],
      });
      setFilterValues(parse_filters([], searchParams))

      getSubcategories({ _id: null });
      getItems({ _id: null })
      setPreloaders((prevState) => ({
        ...prevState,
        item: false,
      }));
      return
    }
    setPreloaders((prevState) => ({
      ...prevState,
      item: true,
    }));
    mainApi
      .getCategoriesWithTree({
        shop_id: SHOP_ID_FOR_API,
        data: levels,
      })
      .then((res) => {
        console.log(res)
        const data =
          res.data.length > 0 ? res.data[res.data.length - 1] : undefined;
        const filters = USING_FILTERS && data.filters ? data.filters.filter((item) => !item.name.startsWith('_') && !(item.name.toLowerCase().indexOf('артикул') >= 0) && !(item.option_name === 'Артикул')) : null
        console.log(data.filters)
        setCategory({
          _id: data._id,
          title: data.name,
          path: res.data,
          categories: [],
          filters: filters
        });
        setFilterValues(parse_filters(filters, searchParams))
        if (data) {
          if (!data.is_final) getSubcategories({ _id: data._id })
          else {
            setPreloaders(prevValue => ({
              ...prevValue,
              subcategories: false,
            }))
          }
          if (!parse_filters(filters, searchParams)) {
            getItems({ _id: data._id })
          } else {
            setPreloaders((prevState) => ({
              ...prevState,
              products: true,
            }));
          }
        }
      })
      .catch((err) => {
        console.log(err);
        navigate(-1)
      })
      .finally(() => {
        setPreloaders((prevState) => ({
          ...prevState,
          item: false,
        }));
      });
  }, [levels]);

  function getSubcategories({ _id }) {
    setPreloaders((prevState) => ({
      ...prevState,
      subcategories: true,
    }));
    mainApi
      .getCategories({
        limit: 25,
        shop_id: SHOP_ID_FOR_API,
        _id: _id ? _id : null,
      })
      .then((res) => {
        setCategory((prevVal) => ({
          ...prevVal,
          categories: res.data,
        }));
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setPreloaders((prevState) => ({
          ...prevState,
          subcategories: false,
        }));
      });
  }

  function getItems({ _id }) {
    const parsedFilters = [];
    searchParams.forEach((value, key) => {
      if (key.startsWith('filter_')) {
        if (!USING_FILTERS) {
          searchParams.delete(key)
          setSearchParams(searchParams, { replace: true })
          return
        }
        console.log({ key, value });
        const filterId = key.replace('filter_', '');

        try {
          // Попробуем распарсить как массив
          const parsedValue = JSON.parse(value);

          if (Array.isArray(parsedValue)) {
            parsedFilters.push({
              filter_id: filterId,
              data: parsedValue,
            });
          } else {
            // Если это не массив, добавляем как есть
            parsedFilters.push({
              filter_id: filterId,
              data: value,
            });
          }
        } catch (error) {
          // Если не получилось распарсить как JSON, просто добавим как строку
          parsedFilters.push({
            filter_id: filterId,
            data: value,
          });
        }
      }
    });

    console.log({ parsedFilters });
    setPreloaders((prevState) => ({
      ...prevState,
      products: true,
    }));
    mainApi
      .getItems({
        shop_id: SHOP_ID_FOR_API,
        category: _id ? _id : null,
        limit: PRODUCTS_LIMIT,
        filters: USING_FILTERS && parsedFilters ? parsedFilters : null,
      })
      .then((res) => {
        console.log(res)
        setCategory((prevVal) => ({
          ...prevVal,
          items: res,
        }));
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setPreloaders((prevState) => ({
          ...prevState,
          products: false,
        }));
      });
  }
  console.log(category)

  function getMoreProducts() {
    const parsedFilters = [];
    searchParams.forEach((value, key) => {
      if (key.startsWith('filter_')) {
        if (!USING_FILTERS) {
          searchParams.delete(key)
          setSearchParams(searchParams, { replace: true })
          return
        }
        console.log({ key, value });
        const filterId = key.replace('filter_', '');

        try {
          // Попробуем распарсить как массив
          const parsedValue = JSON.parse(value);

          if (Array.isArray(parsedValue)) {
            parsedFilters.push({
              filter_id: filterId,
              data: parsedValue,
            });
          } else {
            // Если это не массив, добавляем как есть
            parsedFilters.push({
              filter_id: filterId,
              data: value,
            });
          }
        } catch (error) {
          // Если не получилось распарсить как JSON, просто добавим как строку
          parsedFilters.push({
            filter_id: filterId,
            data: value,
          });
        }
      }
    });
    const last_id = category.items.data[category.items.data.length - 1]._id
    const last_sort = category.items.data[category.items.data.length - 1].sort
    setPreloaders((prevState) => ({
      ...prevState,
      more: true,
    }));
    mainApi
      .getItems({
        shop_id: SHOP_ID_FOR_API,
        category: category && category._id ? category._id : null,
        limit: PRODUCTS_LIMIT,
        last_id: last_id,
        last_sort: last_sort,
        filters: USING_FILTERS && parsedFilters ? parsedFilters : null,
      })
      .then((res) => {
        console.log(res)
        setCategory((prevValue) => ({
          ...prevValue,
          items: {
            data: prevValue.items.data.concat(res.data),
            is_more: res.is_more,
          },
        }));
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setPreloaders((prevState) => ({
          ...prevState,
          more: false,
        }));
      });
  }


  function handleFiltersReset() {
    console.log('RESET', filterValues)
    setFilterValues(parse_filters(category.filters))
    category.filters.forEach((filter) => {
      searchParams.delete(`filter_${filter._id}`);
    });

    // Update the URL with the cleared search params
    setSearchParams(searchParams, { replace: true });

    // getItems({ _id: category._id })
  }

  function handleFiltersApply() {
    const parsedValues = filterValues.filter(item => item.value != null).map((item) => {
      console.log(item, item.value)
      switch (item.data_type) {
        case 'range': {
          if (item.value[0] === item.value[1]) return null
          return ({ filter_id: item._id, data: `${item.value[0]}-${item.value[1]}` });
        }
        case 'integer': {
          return ({ filter_id: item._id, data: JSON.stringify(item.value) });
        }
        case 'string': {
          return ({ filter_id: item._id, data: JSON.stringify(item.value) });
        }
        default: {
          return ({ filter_id: item._id, data: item.value });
        }
      }
    }).filter((item) => Boolean(item))
    // Add each filter to the search params
    parsedValues.forEach(({ filter_id, data }) => {
      try {
        if (Array.isArray(JSON.parse(data)) && JSON.parse(data).length === 0) {
          searchParams.delete(`filter_${filter_id}`);
        }
        else searchParams.set(`filter_${filter_id}`, data);
      }
      catch {
        searchParams.set(`filter_${filter_id}`, data);
      }


    });

    // Update the URL with the new search params
    setSearchParams(searchParams, { replace: true });

    console.log('APPLY', parsedValues);
    // getItems({ _id: category._id })
  }

  function handleOpenFilterPopup() {
    setPopups(prevValue => ({
      ...prevValue,
      filters: true,
    }))
  }
  console.log({ category })

  function handlePopupClose({ name }) {
    setPopups(prevValue => ({
      ...prevValue,
      [name]: false,
    }))
  }

  useEffect(() => {
    if (!popups.filters) { document.body.style.overflow = 'initial'; }
    else { document.body.style.overflow = 'hidden'; }
  });

  useEffect(() => {
    // Настраиваем Intersection Observer
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && category?.items?.is_more) {
          getMoreProducts();
        }
      },
      { root: null, rootMargin: "0px", threshold: 1.0 }
    );

    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }

    return () => {
      if (loadMoreRef.current) {
        observer.unobserve(loadMoreRef.current);
      }
    };
  }, [category]);

  useEffect(() => {
    // Initialize a timeout variable
    const debounceTimer = setTimeout(() => {
      // Automatically apply filters whenever filterValues change
      setCategory((prevVal) => prevVal ? ({
        ...prevVal,
        items: {
          ...prevVal.items,
          is_more: false,
        },
      }) : ({ ...prevVal }));
      if (filterValues) {
        const parsedValues = filterValues
          .filter((item) => item.value != null)
          .map((item) => {
            console.log(item, item.value);
            switch (item.data_type) {
              case 'range': {
                if (item.value[0] === item.value[1]) return null;
                return { filter_id: item._id, data: `${item.value[0]}-${item.value[1]}` };
              }
              case 'integer':
              case 'string': {
                return { filter_id: item._id, data: JSON.stringify(item.value) };
              }
              default: {
                return { filter_id: item._id, data: item.value };
              }
            }
          })
          .filter((item) => Boolean(item));

        // Update the searchParams to reflect the new filter values in the URL
        parsedValues.forEach(({ filter_id, data }) => {
          try {
            if (Array.isArray(JSON.parse(data)) && JSON.parse(data).length === 0) {
              searchParams.delete(`filter_${filter_id}`);
            } else {
              searchParams.set(`filter_${filter_id}`, data);
            }
          } catch {
            searchParams.set(`filter_${filter_id}`, data);
          }
        });
        setSearchParams(searchParams, { replace: true });

        console.log('Filters updated:', parsedValues);
        getItems({ _id: category?._id, filters: parsedValues });
      }
    }, 600);

    // Cleanup the timeout to prevent unnecessary executions
    return () => clearTimeout(debounceTimer);
  }, [filterValues]);

  return (
    <>
      <Helmet>
        <title>{SHOP_NAME} - ...</title>
      </Helmet>
      {preloaders.item ? (
        <div className="catalog__preloader">
          <MiniPreloader />
        </div>
      ) : category ? (
        <div className="catalog">
          <Helmet>
            <title>{SHOP_NAME} - {category.title}</title>
          </Helmet>
          <div className="catalog__content">
            <div className="catalog__crumbs">
              <Link
                to={`/${CATALOG_MAIN_LINK}`}
              >
                <p className="catalog__crumb catalog__crumb_catalog">
                  <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.820312 7.06445C0.82487 6.92318 0.852214 6.79329 0.902344 6.6748C0.957031 6.55632 1.03906 6.44238 1.14844 6.33301L6.41211 1.18555C6.58529 1.01237 6.7972 0.925781 7.04785 0.925781C7.22103 0.925781 7.37598 0.966797 7.5127 1.04883C7.65397 1.13086 7.76562 1.24251 7.84766 1.38379C7.93424 1.52051 7.97754 1.67318 7.97754 1.8418C7.97754 2.09701 7.88184 2.32031 7.69043 2.51172L3.00781 7.06445L7.69043 11.6172C7.88184 11.8132 7.97754 12.0365 7.97754 12.2871C7.97754 12.4603 7.93424 12.6152 7.84766 12.752C7.76562 12.8887 7.65397 12.998 7.5127 13.0801C7.37598 13.1621 7.22103 13.2031 7.04785 13.2031C6.7972 13.2031 6.58529 13.1165 6.41211 12.9434L1.14844 7.7959C1.03451 7.68652 0.950195 7.57259 0.895508 7.4541C0.845378 7.33105 0.820312 7.20117 0.820312 7.06445Z" fill="black" />
                  </svg>
                  Каталог
                </p>
              </Link>
              {category.path ? category.path.map((cat, i) => (
                <Link
                  to={`/${CATALOG_MAIN_LINK}/${buildCategoryPath(
                    category.path,
                    i
                  )}`}
                >
                  <p className="catalog__crumb">
                    <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.64915 3.66477C1.36269 3.66477 1.10109 3.59493 0.864347 3.45526C0.627604 3.31321 0.43821 3.12382 0.296165 2.88707C0.156487 2.65033 0.0866477 2.38873 0.0866477 2.10227C0.0866477 1.81345 0.156487 1.55185 0.296165 1.31747C0.43821 1.08073 0.627604 0.892519 0.864347 0.752841C1.10109 0.610795 1.36269 0.539773 1.64915 0.539773C1.93797 0.539773 2.19957 0.610795 2.43395 0.752841C2.67069 0.892519 2.8589 1.08073 2.99858 1.31747C3.14063 1.55185 3.21165 1.81345 3.21165 2.10227C3.21165 2.38873 3.14063 2.65033 2.99858 2.88707C2.8589 3.12382 2.67069 3.31321 2.43395 3.45526C2.19957 3.59493 1.93797 3.66477 1.64915 3.66477Z" fill="#A5A5A5" />
                    </svg>
                    {cat.name}
                    {/* {i !== category.path.length - 1 ? ` ›` : ""} */}
                  </p>
                </Link>
              )) : null}
            </div>
            <h2 className="catalog__category-title">{category.title}</h2>
            {/* {!preloaders.subcategories ?
              category.categories && category.categories.length > 0 ?
                <div className="catalog__categories-inside">
                  {category.categories.map((cat, i) => (
                    <CategoryCard
                      levels={levels}
                      category={cat}
                      categories={category.categories}
                      i={i}
                    />
                  ))}
                </div>
                : null
              :
              <div className="catalog__categories-preloader">
                <MiniPreloader />
              </div>
            } */}

            <FiltersContext.Provider value={{
              filters: category.filters,
              handleFiltersReset,
              handleFiltersApply,
              filterValues,
              setFilterValues,
              handleOpenFilterPopup,
              isLoading: preloaders.products,
            }}>
              <Products
                category={category}
                preloaders={preloaders}
                items={category.items}
                path={category.path}
                levels={levels}
              />
              <FiltersPopup
                isOpen={popups.filters}
                handleClose={handlePopupClose}
                popupName={'filters'}
                isApplyActive={true}
              />
            </FiltersContext.Provider>
            {category && category.items && category.items.is_more ?
              <button ref={loadMoreRef} className={`catalog__more ${preloaders.more ? 'catalog__more_loading' : ''}`} type='button' onClick={() => {
                getMoreProducts()
              }}>
                {preloaders.more ? <MiniPreloader isLinkColor={true} /> : 'Загрузить еще'}
              </button>
              : null}
          </div>
        </div>
      ) : (
        <div className="catalog__not-found">
          {/* <NotFoundBlock
                text={'Кажется, Вы&nbsp;попытались открыть товар, который пока не&nbsp;поступил к&nbsp;нам в&nbsp;продажу'}
                goToMain={true}
            /> */}
        </div>
      )}
    </>
  );
}

export default Catalog;
